import { Accessible } from '@mui/icons-material';
import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
  src: string;
  avatarText: string;
  primaryText: string;
  secondaryText: string;
  isHandicapped?: boolean;
}

const AvatarWithInfo: React.FC<Props> = ({
  src,
  avatarText,
  primaryText,
  secondaryText,
  isHandicapped,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}>
      <Avatar
        sx={{
          height: 36,
          mr: 1,
          width: 36,
        }}
        variant="rounded"
        src={src}>
        {avatarText}
      </Avatar>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
          variant="inherit">
          {primaryText} {isHandicapped && <Accessible fontSize="small" />}
        </Typography>
        <Typography color="textSecondary" variant="inherit">
          {secondaryText}
        </Typography>
      </Box>
    </Box>
  );
};

export default AvatarWithInfo;
